"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.onExtTracking = exports.onGlobalTracking = exports.extMark = exports.globalMark = exports.getExtKey = void 0;
var events_1 = require("events");
var uuid_1 = require("uuid");
var session_id = uuid_1.v4();
var globalData = {
    enter: 0,
    fetch_list_start: 0,
    fetch_list_succ: 0,
    fetch_list_fail: 0
};
var extData = {};
var getExtKey = function (extUuid, extType) {
    return extUuid + "_" + extType;
};
exports.getExtKey = getExtKey;
var globalMark = function (key) {
    var time = key === 'enter' && global.performance && global.performance.timing && global.performance.timing.navigationStart
        ? global.performance.timing.navigationStart
        : new Date().valueOf();
    globalData[key] = time;
    bus.emit(key, {
        session_id: session_id,
        globalData: globalData
    });
};
exports.globalMark = globalMark;
var extMark = function (key, extUuid, extType) {
    var extKey = exports.getExtKey(extUuid, extType);
    if (!extData[extKey]) {
        extData[extKey] = __assign(__assign({}, globalData), { show_entrance_succ: 0, show_entrance_fail: 0, exec_start: 0, exec_succ: 0, exec_fail: 0, load_supframe_start: 0, load_supframe_succ: 0, load_supframe_fail: 0, load_busiframe_start: 0, load_busiframe_succ: 0, load_busiframe_fail: 0 });
    }
    extData[extKey][key] = new Date().valueOf();
    bus.emit(extUuid + "_" + extType + "_" + key, {
        session_id: session_id,
        globalData: globalData,
        extUuid: extUuid,
        extType: extType,
        extData: extData[extKey]
    });
};
exports.extMark = extMark;
var bus = new events_1.EventEmitter();
var onGlobalTracking = function (param) {
    var key = param.key, handler = param.handler;
    // TODO 只触发一次，防止多次触发误报
    bus.once(key, handler);
};
exports.onGlobalTracking = onGlobalTracking;
var onExtTracking = function (param) {
    var extUuid = param.extUuid, extType = param.extType, key = param.key, handler = param.handler;
    // TODO 只触发一次，防止多次触发误报
    bus.once(extUuid + "_" + extType + "_" + key, handler);
};
exports.onExtTracking = onExtTracking;
var formateDate = function (t) {
    if (t <= 0) {
        return '<EMPTY>';
    }
    else {
        var date = new Date(t);
        var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        var millisencods = date.getMilliseconds() < 100
            ? date.getMilliseconds() < 10
                ? '00' + date.getMilliseconds()
                : '0' + date.getMilliseconds()
            : date.getMilliseconds();
        return hour + ":" + minutes + ":" + seconds + "." + millisencods;
    }
};
// TODO
// @ts-ignore
global.getExtTrackingData = function () { return ({ globalData: globalData, extData: extData, session_id: session_id }); };
// @ts-ignore
global.showExtTrackingData = function () {
    console.log('[tracking]-------------------------------------------------');
    console.log('[tracking]session_id:' + session_id);
    console.log('[tracking]globalData:');
    console.log('[tracking]globalData.enter:' + formateDate(globalData.enter));
    console.log('[tracking]globalData.fetch_list_start:' + formateDate(globalData.fetch_list_start));
    console.log('[tracking]globalData.fetch_list_succ:' + formateDate(globalData.fetch_list_succ));
    console.log('[tracking]globalData.fetch_list_fail:' + formateDate(globalData.fetch_list_fail));
    Object.keys(extData).forEach(function (k) {
        console.log("[tracking]extData." + k + ".show_entrance_succ:" + formateDate(extData[k].show_entrance_succ));
        console.log("[tracking]extData." + k + ".show_entrance_fail:" + formateDate(extData[k].show_entrance_fail));
        console.log("[tracking]extData." + k + ".exec_start:" + formateDate(extData[k].exec_start));
        console.log("[tracking]extData." + k + ".load_supframe_start:" + formateDate(extData[k].load_supframe_start));
        console.log("[tracking]extData." + k + ".load_supframe_succ:" + formateDate(extData[k].load_supframe_succ));
        console.log("[tracking]extData." + k + ".load_supframe_fail:" + formateDate(extData[k].load_supframe_fail));
        console.log("[tracking]extData." + k + ".load_busiframe_start:" + formateDate(extData[k].load_busiframe_start));
        console.log("[tracking]extData." + k + ".load_busiframe_succ:" + formateDate(extData[k].load_busiframe_succ));
        console.log("[tracking]extData." + k + ".load_busiframe_fail:" + formateDate(extData[k].load_busiframe_fail));
    });
    console.log('[tracking]-------------------------------------------------');
};
